import { render, staticRenderFns } from "./AdminDirectory.vue?vue&type=template&id=b8d5ada2&scoped=true&"
import script from "./AdminDirectory.vue?vue&type=script&lang=js&"
export * from "./AdminDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d5ada2",
  null
  
)

export default component.exports